import axiosClient from "../../../../axiosClient"

export default async (preCheckId) => {
    const result = await axiosClient.get(`/consumer-report/${preCheckId}`)
    return result.data
}
